import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Get charging point details by Id
   */
  getLogById: (id: string): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/ocpp-logs/${id}`);
  },
  /**
   * Get charging point details by Id
   */
  listFilters: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/ocpp-logs/list-filters`);
  },
};
